module.exports = __webpack_public_path__ + "static/media/iterative_learning_dark.2decd8ee.svg";